import { Link } from 'react-router-dom';

export default function ComparisonSection() {
  return (
    <section id="comparisons" className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-8">
              Compare<br />
              Spreadsheet<br />
              Platforms
            </h2>

            <div className="grid grid-cols-3 gap-6 mb-10">
              <div className="border-r border-background-200 pr-4">
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">10x</div>
                <p className="text-xs md:text-sm text-foreground-600 font-body mt-2 leading-relaxed">Faster Than Manual</p>
              </div>
              <div className="border-r border-background-200 pr-4">
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">50+</div>
                <p className="text-xs md:text-sm text-foreground-600 font-body mt-2 leading-relaxed">Curated Categories</p>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">100%</div>
                <p className="text-xs md:text-sm text-foreground-600 font-body mt-2 leading-relaxed">Verified Links</p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 pr-4 font-label font-semibold text-foreground-900">Feature</th>
                    <th className="text-left py-3 px-4 font-label font-semibold text-primary-600">Hipobuy Spreadsheet</th>
                    <th className="text-left py-3 pl-4 font-label font-semibold text-foreground-600">Normal Search</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-background-200">
                  <tr>
                    <td className="py-3 pr-4 text-foreground-700 font-body">Organization</td>
                    <td className="py-3 px-4 text-primary-600 font-body font-medium">High</td>
                    <td className="py-3 pl-4 text-foreground-500 font-body">Low</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-foreground-700 font-body">Research Speed</td>
                    <td className="py-3 px-4 text-primary-600 font-body font-medium">Fast</td>
                    <td className="py-3 pl-4 text-foreground-500 font-body">Slow</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-foreground-700 font-body">Comparison</td>
                    <td className="py-3 px-4 text-primary-600 font-body font-medium">Easy</td>
                    <td className="py-3 pl-4 text-foreground-500 font-body">Difficult</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-foreground-700 font-body">Beginner Friendly</td>
                    <td className="py-3 px-4 text-primary-600 font-body font-medium">Yes</td>
                    <td className="py-3 pl-4 text-foreground-500 font-body">Medium</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-8">
              <Link
                to="/hipobuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 font-label transition-colors cursor-pointer"
              >
                View Full Comparison Guide
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="bg-accent-100/60 rounded-3xl p-8 md:p-12 aspect-square flex items-center justify-center relative overflow-hidden">
            <div className="absolute top-8 right-8 w-24 h-24 rounded-2xl bg-accent-200/70 rotate-12"></div>
            <div className="absolute bottom-12 left-8 w-32 h-32 rounded-full bg-accent-300/40"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-3xl bg-accent-400/30 -rotate-6"></div>
            <div className="relative z-10 text-center">
              <div className="text-6xl md:text-7xl font-heading font-bold text-accent-600 mb-3">2026</div>
              <p className="text-foreground-700 font-body text-sm md:text-base">
                Updated spreadsheet<br />resources &amp; guides
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}